import React from "react";

const Summary = (props) => {
    const { formattedTotal, onProccedPay } = props;

    return (
        <div className="cart-paydetail w-100">
            <div className="box-border">
                <div className="order-total d-flex justify-content-center align-items-center">
                    <span className="main-total fw-bold">Order Summary</span>
                </div>
                <div className="payment-detail">
                    <div className="card-border-bottom d-flex justify-content-between align-items-center">
                        <span className="subtotal">Subtotal</span>
                        <span className="amount">₹ {formattedTotal}</span>
                    </div>

                    <div className="card-border-bottom d-flex justify-content-between align-items-center">
                        <span className="shipping">Shipping (Standard)</span>
                        <span className="amount">Free</span>
                    </div>
                </div>
                <div className="order-total d-flex justify-content-between align-items-center pt-2">
                    <span className="main-total fw-bold">Total Cost </span>
                    <span className="amount">₹ {formattedTotal}</span>
                </div>

                <div className="checkout mt-md-2 pt-2">
                    <button className="web_button" onClick={onProccedPay}>
                        Checkout
                    </button>
                </div>
            </div>
        </div>

    )
}

export default Summary;